import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  size?: 'lg' | 'sm';
  tone?: 'light' | 'dark';
};
export function Countdown({
  size = 'lg',
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units: {
    value: string;
    label: string;
  }[] = [{
    value: hours,
    label: 'hours'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  const isLarge = size === 'lg';
  const box = tone === 'dark' ? 'bg-white/10 text-white border-white/20' : 'bg-white text-ink border-sage-soft';
  const label = tone === 'dark' ? 'text-white/70' : 'text-ink-muted';
  return <div className="flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-87" data-mp="372t62to8r0zl">
      {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-88" data-mp="15ad93td7skm1" data-mpi={i}>
          {i > 0 && <span aria-hidden="true" className={`font-serif font-bold ${isLarge ? 'text-3xl sm:text-4xl' : 'text-xl'} ${tone === 'dark' ? 'text-white/50' : 'text-ink-muted'}`} data-id="element-89" data-mp="y0wuxmh0xyl0">
              :
            </span>}
          <div className={`rounded-xl border shadow-sm text-center tabular-nums ${box} ${isLarge ? 'px-4 py-3 sm:px-6 sm:py-4 min-w-[76px] sm:min-w-[96px]' : 'px-3 py-2 min-w-[56px]'}`} data-id="element-90" data-mp="17t2k6ofw61wi">
            <div className={`font-serif font-bold leading-none ${isLarge ? 'text-3xl sm:text-5xl' : 'text-xl'}`} data-id="element-91" data-mp="a3r55zfj4hl1">
              {unit.value}
            </div>
            <div className={`uppercase tracking-widest mt-1 ${label} ${isLarge ? 'text-[11px]' : 'text-[9px]'}`} data-id="element-92" data-mp="k1f3ezccg77y">
              {unit.label}
            </div>
          </div>
        </React.Fragment>)}
    </div>;
}